import { ANNUAL_DECLARATION_YEAR } from '@/features/onboarding/constants/annualDeclaration';

const ROUTES = {
	//? AUTH
	SEND_OTP_CODE: '/send-otp',
	VERIFY_OTP_CODE: '/verify-otp',
	GENERATE_OTP: '/generate-otp',

	//? USER
	USER_PROFILE: '/profile/',

	//? PAGES
	ROOT: '/',
	LOGIN: '/login/',
	INVOICING: '/invoice/',
	NEW_INVOICE: '/new-invoice',
	INVOICE_DETAIL: `/invoice/:invoice_id/`,

	//? FACTURACIÓN — el flujo de facturación, sobre el monolito Go (heru-fiscal-engine).
	//? Relevó a `/invoice/`, que ya no sirve el legacy: solo redirige aquí
	//? (`LegacyInvoicingRedirect`).
	//? Una URL por vista, porque Amplitude calcula los heatmaps por URL y un wizard
	//? bajo una sola ruta nace ciego. Sin barra final.
	FACTURACION: '/facturacion',
	FACTURACION_STAMPS: '/facturacion/sellos',
	FACTURACION_PLANES: '/facturacion/planes',
	FACTURACION_NEW_CLIENT: '/facturacion/cliente/nuevo',
	FACTURACION_CONCEPTS: '/facturacion/nuevo/conceptos',
	FACTURACION_PAYMENT: '/facturacion/nuevo/pago',
	FACTURACION_REVIEW: '/facturacion/nuevo/revisar',
	FACTURACION_STAMPED: '/facturacion/f/:folio',
	FACTURACION_QR: '/facturacion/mi-qr',
	FACTURACION_QR_REQUESTS: '/facturacion/mi-qr/solicitudes',
	FACTURACION_QR_REQUEST: '/facturacion/mi-qr/solicitudes/:id',
	FACTURACION_MY_INVOICE: '/facturacion/mis-facturas/:periodo?/:uuid',
	FACTURACION_MARCA: '/facturacion/marca',

	//? FACTURA POR QR — página pública que abre el cliente final del negocio.
	//? `/factura-qr/:slug` es la liga impresa en los pósters y la de los correos de
	//? los dos motores: no cambia nunca, y todo el flujo público vive debajo porque
	//? la app nativa solo deja sin login ese prefijo. `/facturacion-qr/*` fue la
	//? base de la página nueva mientras convivió con la vieja y solo redirige aquí.
	QR_PUBLIC: '/factura-qr/:slug',
	QR_PUBLIC_REQUEST: '/factura-qr/s/:publicId',
	QR_PUBLIC_RETIRED: '/facturacion-qr/:slug',
	QR_PUBLIC_RETIRED_REQUEST: '/facturacion-qr/s/:publicId',
	QR_PUBLIC_RETIRED_STEP: '/facturacion-qr/:slug/*',
	PAYMENT_LINK_RESULT: '/payment-link-result',
	SHOPPING: '/shopping/',
	ACTIVE_SUBS_LIST: '/active-subscriptions/',
	SUCCESSFUL_PURCHASE: '/successful-purchase/',
	TAX_PROFILE: '/tax-profile/',
	ACCOUNT_HERU: '/account-heru/',
	PAYMENT_METHODS: '/payment-methods/',
	REFERRALS: '/referidos/',
	REFERRAL_CAPTURE: '/r/:code',
	// URL corta de la campaña de un aliado, la que el aliado pega en SU sitio.
	// Equivale a `/?partner=<aliado>`; el `?calc=` de Calcu.mx viaja colgado de
	// ella. Un aliado con URL propia = una entrada más aquí y otra en el router.
	CALCUMX_CAMPAIGN: '/calcumx',
	TUAL_CAMPAIGN: '/tual',
	PLATA_CAMPAIGN: '/plata',
	MASLOW_CAMPAIGN: '/maslow',
	RAPPI_CERTIFICATES: '/rappi-certificates/',
	ZUBALE_CERTIFICATES: '/zubale-certificates/',
	GENERAL_CERTIFICATES: '/certificates/',
	ANNUAL_DECLARATION: '/annual-declaration',
	FISCAL_ADVISOR: '/fiscal-advisor',
	NEW_IMS_REGULATIONS: '/new-imss-regulations',
	PROMO: '/promo',
	//? PLANS
	PLANS_AND_PRICES: '/plans/',
	PLANS_SECTION: '/plans/:section',
	PLANS_SUBSCRIPTIONS: '/plans/subscriptions',
	PLANS_ANNUALS: '/plans/annuals',
	PLANS_REGULARIZATIONS: '/plans/regularizations',
	PLANS_ASAT: '/plans/asat',
	CHECKOUT: '/checkout/',
	BANNER_PREVIEW: '/banner-preview',
	PAYMENT: '/payment/',
	PRODUCTS: '/products/',
	CART: '/cart/',
	SUBSCRIPTION_DETAIL: '/shopping/subscriptions/:id',
	ORGANIZATION_SUCCESS_LINK: '/organization-success-link',

	//? TAXES
	TAXES: '/taxes/',

	//? SERVICE STATUS
	SERVICE_STATUS: '/service-status',
	SERVICE_STATUS_DETAIL: '/service-status/:id',

	//? PENDING ORDERS
	PENDING_REFERENCES: '/pending-references',

	//? FLOW TRANSACTION
	GENERAL_FFT: '/fft',
	DETAILS_FFT: '/fft/detail',
	//? ONBOARDING
	// v3 host (motor JSON versionado). Vive pero inalcanzable — nadie navega aquí
	// aún; la integración (redirect + chrome) es un PR posterior.
	ONBOARDING_V3: '/onboarding',
	// Deep-link al nodo `ally_grid` del host v3 (el id DEBE igualar la clave del
	// flow JSON). Reemplaza la vieja ruta v2 '/onboarding-v2/ally/grid', muerta
	// en v3. La entrada de shell "Aliados oficiales" navega aquí.
	ALLIES_GRID: '/onboarding/ally_grid',
	// Deep-links to the Zubale nodes of the v3 host (same contract as
	// ALLIES_GRID: the id MUST match the flow JSON key). The home milestone and
	// the home banner of a Zubale partner open the hub; whoever is not enrolled
	// yet goes to the enrollment screen.
	ZUBALE_HUB: '/onboarding/zubale_perfil',
	// The ally hub as its own page, outside the onboarding walk: every link out
	// of the flow (platforms card, home banner, milestone) opens this one, so a
	// partner without an onboarding record lands on the hub, never on welcome.
	ALLY_HUB: '/plataformas/:allyId',
	ZUBALE_ENROLLMENT: '/onboarding/zubale_no_inscrito',
	// Familia de URLs del onboarding v2, muerta con el motor v3. Sigue viva SOLO
	// como puente: los aliados (Zubale) ya repartieron
	// '/onboarding-v2/ally/benefit/zubale/' y esos links no se pueden reimprimir.
	// La traduce legacyAllyDeeplinkLoader a un target de v3.
	LEGACY_ONBOARDING_V2: '/onboarding-v2/*',

	//? SUPPORT
	SUPPORT_FORM: '/support-form',
	SUPPORT: '/support',

	//? APPROVAL DECLARATIONS
	APPROVAL_DECLARATIONS: '/approval-declarations',
	DETAIL_APPROVAL: '/detail-approval',
	DENIED_DECLARATIONS: '/denied-declarations',

	//? DECLARATIONS
	DECLARATIONS: '/declarations',
	DECLARATION_PERIOD: '/declarations/:period',
	DECLARATIONS_CATCH_UP: '/declarations/ponte-al-dia',
	DECLARATIONS_ANNUAL: `/declarations/anual-${ANNUAL_DECLARATION_YEAR}`,
	DECLARATIONS_APPROVE_MANY: '/declarations/por-aprobar',
	DECLARATION_INVOICES: '/declarations/:period/facturas',
	DECLARATION_INVOICE: '/declarations/:period/facturas/:movementId',

	//? SAT INBOX
	SAT_INBOX: '/sat-inbox',

	//? SAT ID
	SAT_ID: '/sat-id',

	//? TAX MAILBOX
	TAX_MAILBOX: '/tax-mailbox',

	//? WRAPPED
	WRAPPED: '/wrapped',

	//? FACTURACIÓN — registrar el pago de una factura PPD (complemento de pago, tipo P).
	//? Una URL por paso, como el wizard del ingreso.
	FACTURACION_COMPLEMENTO: '/facturacion/complemento',
	FACTURACION_COMPLEMENTO_PAGO: '/facturacion/complemento/pago',
	FACTURACION_COMPLEMENTO_REVISAR: '/facturacion/complemento/revisar',
	FACTURACION_COMPLEMENTO_LISTO: '/facturacion/complemento/listo',
};

const ROUTES_SLUGS: Record<string, string> = {
	HOME: 'home',
	PLANS: 'plans-legacy',
	PLANS_AND_PRICES: 'plans',
	INVOICING: 'invoice',
	FACTURACION: 'facturacion',
	FACTURACION_QR: 'facturacion-mi-qr',
	FISCAL_DOCUMENTS: 'fiscal-documents',
	TAXES: 'taxes',
	SERVICE_STATUS: 'service-status',
	RAPPI_CERTIFICATES: 'rappi-certificates',
	ZUBALE_CERTIFICATES: 'zubale-certificates',
	GENERAL_CERTIFICATES: 'certificates',
	PROFILE: 'profile',
	REFERRALS: 'referidos',
	LOGOUT: 'logout',
	ANNUAL_DECLARATION: 'annual-declaration',
	SUPPORT_FORM: 'support-form',
	SUPPORT: 'support',
	NEW_IMSS_REGULATIONS: 'new-imss-regulations',
	DECLARATIONS: 'declarations',
	SAT_INBOX: 'sat-inbox',
};

export const allyHubPath = (allyId: string) => ROUTES.ALLY_HUB.replace(':allyId', allyId);

export default ROUTES;
export { ROUTES_SLUGS };
